import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../@types/RootState';

const initialState = 0;

const slice = createSlice({
  name: 'getStoreFamilyClusterModal/totalElements',
  initialState,
  reducers: {
    SET_GET_STORE_FAMILY_CLUSTER_MODAL_TOTAL_ELEMENTS: (_state, { payload }: PayloadAction<number>) => payload,
    RESET_GET_STORE_FAMILY_CLUSTER_MODAL_TOTAL_ELEMENTS: () => initialState,
  },
});

export const selectorGetStoreFamilyClusterModalTotalElements = (state: RootState) => {
  return state.getStoreFamilyClusterModalReducer.totalElements;
};

export const { SET_GET_STORE_FAMILY_CLUSTER_MODAL_TOTAL_ELEMENTS, RESET_GET_STORE_FAMILY_CLUSTER_MODAL_TOTAL_ELEMENTS } = slice.actions;

export default slice.reducer;
